import { useEffect, useState } from 'react';
import { getUser } from '../utils/API';
import { useDispatch, useSelector } from 'react-redux';
import { setLocalstorageLogin } from '../helper';
import { showMAPErrorLogin, showModalPremium } from '../utils/bootstrapUI';

const useCheckIbidLogin = ({ defaultLoading = false }) => {
  const [stateData, setStateData] = useState({
    isLoading: defaultLoading,
    error: null,
  });

  const errorNullLoadingFalse = () => setStateData({
    isLoading: false,
    error: null,
  });

  const dispatch = useDispatch()

  const { day_left, isNotified } = useSelector((state) => state.user);

  const handleUserAlreadyLoggedIn = async (userID) => {
    try {
      const userDetail = await getUser(userID);

      dispatch({ type: 'SET_USER_PROFILE', payload: userDetail.data });

      if (!userDetail || (userDetail.response && userDetail.response.status !== 200)) {
        localStorage.clear()
        showMAPErrorLogin()
      }
      else {
        const countDayLeft = userDetail.data.map ?
          (new Date(userDetail.data.map.SubscriptionDue).getTime() - new Date().getTime()) / (1000 * 3600 * 24) : 0;
        localStorage.setItem('distance', parseInt(Math.ceil(countDayLeft)));

        setLocalstorageLogin({
          email: userDetail.data.users.Email,
          name: userDetail.data.users.Name,
          due: userDetail.data.map ? userDetail.data.map.SubscriptionDue : null,
          status: userDetail.data.map ? Number(userDetail.data.map.SubscriptionStatus) : null,
        });


        if (!isNotified && day_left && day_left <= 7) {
          showModalPremium();
        }
      }

      setStateData({
        isLoading: false,
        error: null,
      });
    } catch (error) {
      setStateData({
        isLoading: false,
        error,
      });
    }
  }

  useEffect(() => {
    setStateData({
      isLoading: true,
      error: null,
    });

    if (localStorage.getItem('token')) { //already login
      handleUserAlreadyLoggedIn(localStorage.getItem('id'))
    }

    errorNullLoadingFalse()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    error: stateData.error,
    isLoading: stateData.isLoading,
  };
};

export default useCheckIbidLogin;
